<template>
  <div class="image-preview-container">
    <!-- png、jpg、gif、jpeg -->
    <img class="img" :src="src"/>
  </div>
</template>

<script>
export default {
  name: 'tbh-image-preview',
  data () {
    return {
      src: ''
    }
  },
  methods: {
  },
  created () {
    if (this.$route.query.name) {
      document.title = this.$route.query.name
    }
    this.src = this.$route.query.src
  }
}
</script>

<style lang="scss">
  .image-preview-container {
    display: flex;
    height: 100%;
    background-color: black;
    img.img {
      margin: auto;
      max-width: 100%;
      max-height: calc(100% - 70px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/globalComponent/publicPreview/components/tbh-image-preview.vue